module.exports = __webpack_public_path__ + "static/media/close.397db1f0.svg";